import { useGlobalAlert as globalAlert } from "hooks/useAlert";
import { ActionFunctionArgs } from "react-router-dom";
import { api } from "services/api.service";
import { isAxiosError } from "utils/helpers";
import * as yup from "yup";
import { mutate } from "swr";

export async function action({ request }: ActionFunctionArgs) {
  const formData = await request.formData();
  const data = Object.fromEntries(formData.entries());

  const formValidationSchema = yup.object().shape({
    manifestId: yup.string().required(),
    unitCount: yup.number().required().positive(),
    customerName: yup.string().required(),
    warehouseId: yup.number().required(),
    shippingMethod: yup.string().required().oneOf(["ground", "freight", "local_pickup"]),
    dueDate: yup
      .string()
      .matches(/^\d{4}-\d{2}-\d{2}$/, "Must be in YYYYMMDD format")
      .required(),
    invoiceId: yup.string().optional(),
    paymentDate: yup
      .string()
      .matches(/^\d{4}-\d{2}-\d{2}$/, "Must be in YYYY-MM-DD format")
      .optional()
      .nullable()
      .transform((value) => (value === "" ? undefined : value)),
    depositTo: yup.string().optional(),
    soldPrice: yup
      .number()
      .optional()
      .nullable()
      .transform((value, originalValue) => (originalValue === "" || originalValue == null ? undefined : value))
      .min(0),
    paymentMethod: yup
      .string()
      .oneOf(["ach", "credit", ""])
      .optional()
      .transform((value) => (value === "" ? undefined : value)),
  });

  try {
    const validatedData = await formValidationSchema.validate(data);
    const payload = Object.fromEntries(
      Object.entries(validatedData).filter(([, value]) => value !== undefined && value !== null && value !== ""),
    );
    const response = await api.request({
      method: "POST",
      url: "/bulk_orders",
      data: payload,
      params: {
        type: new URL(request.url).searchParams.get("type"),
      },
    });

    mutate((key) => typeof key === "string" && key.startsWith("bulk_orders"));

    if (response.status >= 200 && response.status < 300) {
      globalAlert.alertSuccess("Bulk order created successfully.");
      return null;
    }
    return { error: "Unexpected response" };
  } catch (error: unknown) {
    if (isAxiosError(error)) globalAlert.alertError(`Failed to create bulk order: ${error.response?.data.message}`);
    else globalAlert.alertError("Failed to create bulk order.");
    return { error: true };
  }
}
